import Icon from '@ant-design/icons';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import type { ComponentProps } from 'react';

/**
 * Toolbar glyph for the "select" tool — a classic OS pointer-arrow
 * cursor, the universal GIS identify-tool affordance. Uses
 * `currentColor` so the Ant Design button primary/default states
 * re-colour it automatically.
 */
function PointerSvg(props: Partial<CustomIconComponentProps>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
      <path
        d="M5 2.5 L5 20 L9.2 16.1 L12 22 L14.6 20.8 L11.8 14.9 L17.5 14.9 Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.6"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function PointerGlyph(props: ComponentProps<typeof Icon>) {
  return <Icon component={PointerSvg} {...props} />;
}
